<template>
    <child-layout :loading="listLoading || sseLoading" :routerId="id">
        <div class="band-list">
			<div class="empty" v-if="listLoading">
				<loading />
			</div>

			<template v-else-if="bandList && bandList.length">
				<band
					v-for="(item, $bandIndex) in bandList"
					:key="$bandIndex"
					:name="item.users.length ? item.users[0].name : item.band_name"
					:user="item.users[0] || null"
					:disabled="false"
					:logged-in="item.users.length > 0"
					@login="openLogin(item)"
					@edit="openEdit(item)"
                    @logout="openLogout(item)"
				></band>
			</template>

			<div class="empty" v-else>
				<img src="@/assets/img/empty-state.png" alt="band">
				<h3>{{ $t('no_available_band_yet') }}</h3>
                <h4>{{ $t('connect_a_band') }}</h4>
			</div>

            <modal v-if="isLogin">
                <form-type
                    class="form-type"
                    v-if="!userType"
                    @cancel="cancelLogin()"
                    @input="userType = $event"
                ></form-type>

                <form-guest
                    v-if="userType === 'editUser' || userType === 'signup'"
					:value="userForm"
                    :loading="buttonLoading"
					:error="error"
                    :type="userType"
                    :title="$t('input_details')"
                    :submitText="$t('ok')"

					@onCloseForm="clearForm()"
                    @cancel="cancelLogin()"
                    @submit="save($event)"
                ></form-guest>

                <form-registered
                    v-if="userType === 'registered'"
					:error="error"
                    :title="$t('input_details')"
                    :submitText="$t('ok')"
                    @cancel="cancelLogin()"
                    @submit="save($event)"
                ></form-registered>
            </modal>

            <modal v-if="isLogout">
                <div class="logout-wrapper">
                    <h3>{{ $t('confirmation') }}</h3>
                    <p class="description">{{ $t('review_details') }}</p>
                    <div class="details-wrapper">
                        <p class="label">{{ $t('name') }}:</p>
                        <p class="details">{{ this.band.users[0].name }}</p>
                    </div>
                    <div class="details-wrapper">
                        <p class="label">{{ $t('email') }}:</p>
                        <p class="details">{{ this.band.users[0].email }}</p>
                    </div>
                    <div class="details-wrapper">
                        <p class="label">{{ $t('weight') }}: </p>
                        <p class="details">{{ this.band.users[0].weight }}(kg)</p>
                    </div>
                    <div class="details-wrapper">
                        <p class="label">{{ $t('birthday') }}:</p>
                        <p class="details">{{ this.band.users[0].birthday | dateTime('MMMM DD, YYYY') }}</p>
                    </div>
                    <div class="details-wrapper">
                        <p class="label">{{ $t('gender') }}:</p>
                        <p class="details">{{ this.band.users[0].gender }}</p>
                    </div>

                    <div class="button-wrapper">
                        <button class="button--ok" @click="logout()" :disabled="buttonLoading">{{ $t('confirm') }}</button>
                        <button class="button--cancel" @click="cancelLogout()" :disabled="buttonLoading">{{ $t('cancel') }}</button>
                    </div>
                </div>
            </modal>

			<!-- <modal v-if="userType === 'editUser'">
				<form-guest
                    submitText="Save"
					title="Edit Info Details"

					:value="userForm"
					:loading="buttonLoading"

					:error="error"

					@close="clearForm()"
					@cancel="clearForm()"
					@submit="edit($event)"
                ></form-guest>
			</modal> -->
        </div>
    </child-layout>
</template>

<script>
import * as router from '@/store/router/app.js'
import { mapFields } from 'vuex-map-fields'

import ChildLayout from '@/components/layouts/ChildLayout.vue'
import Band from '@/components/band/Band.vue'
import Modal from '@/components/layouts/Modal.vue'
import FormType from '@/components/band/FormType.vue'
import FormGuest from '@/components/band/FormGuest.vue'
import FormRegistered from '@/components/band/FormRegistered'

export default {
	props: ['id'],

	data () {
		return {
			band: null,

			url: '',
			sse: null,
			sseLoading: false,
			apiUrl: process.env.VUE_APP_API_URL,
			apiUrlVersion: process.env.VUE_APP_API_VERSION,
			token: this.$store.getters['auth/getField']('token'),

			pollingTimeout: null
		}
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['router/']) {
			this.$store.registerModule('router', router.default)
		}
	},

	async created () {
		this.loadNewData()
	},

	async beforeDestroy () {
		if (this.pollingTimeout) clearTimeout(this.pollingTimeout)
	},

	computed: {
		...mapFields('router', [
			'bandList',
			'listLoading',
			'isLogin',
			'isLogout',
			'userType',
			'userForm',
			'buttonLoading',
			'error'
		])
	},

	methods: {
		/* Created Lifecycle Methods */
		async loadNewData () {
			this.$store.commit('router/SET_LIST_LOADING', true)
			await this.fetchPolling()
			this.$store.commit('router/SET_LIST_LOADING', false)
		},

		async fetchPolling () {
			if (this.pollingTimeout) clearTimeout(this.pollingTimeout)
			await this.$store.dispatch('router/getBandList', this.id)

			this.pollingTimeout = setTimeout(async () => {
				this.fetchPolling()
			}, 10000)
		},

		clearForm () {
			this.band = null
			this.userType = ''
			this.$store.commit('router/clearUserForm')
			this.$store.commit('router/clearError')
			console.log(1)
		},

		cancelLogin () {
			this.band = null
			this.userType = ''
			this.isLogin = false
			this.$store.commit('router/clearUserForm')
			this.$store.commit('router/clearError')
		},

		cancelLogout () {
			this.band = null
			this.isLogout = false
		},

		openLogout (e) {
			this.band = e
			this.isLogout = true
		},

		openLogin (e) {
			this.userType = null
			this.band = e
			this.isLogin = true
		},

		openEdit (e) {
			this.userForm.name = e.users[0].name
			this.userForm.email = e.users[0].email
			this.userForm.weight = e.users[0].weight
			this.userForm.birthday = new Date(e.users[0].birthday)
			this.userForm.sex = e.users[0].gender
			this.band = e

			this.userType = 'editUser'
			this.isLogin = true
		},

		loginGuest (e) {
			const form = new FormData()

			form.append('facebook_id', e.facebookId)
			form.append('router_id', this.id)
			form.append('band_id', this.band.id)
			form.append('type', 'guest')
			form.append('name', e.name)
			form.append('email', e.email)
			form.append('weight', e.weight)
			form.append('age', e.age)
			form.append('gender', e.sex)

			this.$store.dispatch('router/loginGuest', form)
		},

		loginRegistered (e) {
			const form = new FormData()

			form.append('router_id', this.id)
			form.append('band_id', this.band.id)
			form.append('type', 'old')
			// form.append('name', e.name)
			form.append('email', e.email)
			form.append('password', e.password)
			form.append('weight', e.weight)
			form.append('age', e.age)
			form.append('gender', e.sex)

			this.$store.dispatch('router/loginGuest', form)
		},

		logout () {
			const form = new FormData()
			form.append('band_id', this.band.id)
			form.append('user_id', this.band.users[0].id)
			form.append('router_id', this.id)
			this.$store.dispatch('router/logout', { form })
		},

		edit (e) {
			const form = new FormData()

			form.append('router_id', this.id)
			form.append('band_id', this.band.id)
			form.append('id', this.band.users[0].id)
			form.append('name', e.name)
			form.append('email', e.email)
			form.append('weight', e.weight)
			form.append('age', e.age)
			form.append('gender', e.sex)

			this.$store.dispatch('router/editUser', form)
		},

		async save (e) {
			if ((this.userType === 'signup' ||
				this.userType === 'signup') &&
				process.env.NODE_ENV === 'production' &&
				process.env.VUE_APP_SERVER !== 'test'
			) {
				const isEmailValid = await this.$options.filters.verifyEmail(e.email)

				if (!isEmailValid) {
					this.error.email = 'Please input a valid email.'
					this.buttonLoading = false
					return false
				}
			}

			const form = this.appendForm(e)
			await this.$store.dispatch('router/connectUser', {
				form,
				modalType: this.userType
			})
		},

		appendForm (e) {
			const {
				name,
				email,
				password,
				weight,
				birthday,
				sex
			} = e

			const form = new FormData()

			form.append('band_id', this.band.id)
			form.append('router_id', this.id)
			form.append('email', email)

			switch (this.userType) {
			case 'editUser':
				form.append('id', this.band.users[0].id)
				break
			case 'registered':
				form.append('type', 'old')
				form.append('password', password)
				break
			case 'signup':
				form.append('type', 'new')
				form.append('password', password)
				break
			// case 'facebookUser':
			// 	form.append('facebook_id', facebookId)
			// 	break
			}

			if (this.userType !== 'registered') {
				form.append('name', name)
				form.append('weight', weight)
				form.append('birthday', this.$options.filters.dateTime(birthday, 'YYYY-MM-DD'))
				form.append('gender', sex)
			}

			return form
		}

		// clearAll () {
		// 	this.isLogin = false
		// 	this.userType = null
		// 	this.band = null

		// 	this.$store.commit('router/clearUserForm')
		// 	this.$store.commit('router/clearError')
		// }
	},

	components: {
		ChildLayout,
		Band,
		FormType,
		FormGuest,
		FormRegistered,
		Modal
	}
}
</script>

<style lang="scss" scoped>
.band-list {
    width: 100%;
	// min-height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    .logout-wrapper {
        background-color: #fff;
        border-radius: 3px;
        padding: 35px 50px;
        max-width: 470px;

        h3 {
            font-size: 16px;
            color: #778395;
            padding-bottom: 25px;
            border-bottom: 1px solid #E6EAF2;
            margin-bottom: 25px;
        }

        .description {
            font-size: 16px;
            color: #97A1B2;
            margin-bottom: 30px;
        }

        .details-wrapper {
                display: flex;
                margin-bottom: 20px;

            .label {
                width: 60px;
                font-size: 14px;
                color: #778395;
                margin-right: 20px;
            }

            .details {
                font-size: 14px;
                color: #778395;
            }

        }

        .button-wrapper {
            margin-top: 45px;
            display: flex;
            flex-direction: row-reverse;

            button {
                &:last-child {
                    margin-right: 10px;
                }

                &:disabled {
                    pointer-events: none;
                    opacity: 0.5;
                }
            }
        }

    }

}

.band {
    flex-shrink: 0;
    margin: 1rem;
}

form {
    width: 500px;
}

.form-type {
    width: 400px;
}

.empty {
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: #B2C1D8;
    margin-top: 200px;

	img {
		width: 200px;
		margin-bottom: 10px;
		filter: grayscale(100%);
	}

    h3 {
        margin-bottom: 15px;
        font-size: 22px;
    }

    h4 {
        font-size: 22px;
        font-weight: 400;
    }
}

@include mobile {
	.band-list {
		display: block;
	}
}
</style>
